
















































import { Component, Vue } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import LayoutCompactFooterOnly from '@/layouts/LayoutCompactFooterOnly.vue'
import Logo from '@/components/Logo.vue'
import LogoService from '@/services/LogoService'
import StoreTourModeService from '@/services/StoreTourModeService'

@Component({
  components: {
    LayoutCompactFooterOnly,
    ValidationProvider,
    ValidationObserver,
    Logo
  }
})
export default class SelectStoreSuccess extends Vue {
  public items: any = ''
  public image: string = ''
  private data: any

  async created() {
    await LogoService.getAvatar().then((res: any) => {
      this.image = res.data.items
    })
    if (localStorage.getItem('items')) {
      this.data = localStorage.getItem('items')
      this.items = JSON.parse(this.data)
    } else if (localStorage.getItem('tour_mode')) {
      StoreTourModeService.getAllStoreTourMode()
        .then((res: any) => {
          this.items = res.data.items
        })
        .catch((err: any) => {
          console.log(err)
        })
    } else {
      this.$router.push('select-store')
    }
  }

  public selectStore(item: any) {
    localStorage.setItem('store_id', item.id)
    if (localStorage.getItem('tour_mode') === 'on' && !localStorage.getItem('register_mode')) {
      localStorage.setItem('store_uuid', item.uuid)
      localStorage.setItem('store_name', item.name)
      this.$router.push({
        name: 'home'
      })
    } else {
      this.$router.push({
        name: 'member-register'
      })
    }
  }
}
